import { ThunkResult } from '../../store'
import palletApi from '../../apis/pallet.api'
import palletService from '../../services/pallet.service'
import { replaceResult, replaceResultData } from './Inventories.slice'

export function paginate (): ThunkResult<void> {
  return (dispatch, getState) => {
    const { page, limit, search, status, startAt, endAt, item, workOrder, code } = getState().inventories
    const params = { page, limit, search, status, startAt, endAt, item, workOrder, code }

    console.log("Triggering API with: "+ JSON.stringify(params))

    palletApi.paginateInventories(params, paginate => {
      if (!paginate) return
      dispatch(replaceResult(paginate))
    })
  }
}

export function deleteInventory (id: number): ThunkResult<void> {
  return (dispatch, getState) => {
    palletApi.delete(id, item => {
      if (!item) return
      const { result } = getState().inventories
      const data = palletService.delete(result.data, id)
      dispatch(replaceResultData(data))
    })
  }
}
